import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { useCarouselRewards } from 'components/features/components/rewards-section/use-carousel-rewards';
import { RewardsCarousel } from 'components/rewards-carousel';
import { useLoyaltyFeaturedRewardsQuery } from 'generated/sanity-graphql';

import { FeaturedRewardsContainer, Title } from './loyalty-featured-rewards.styled';

const LoyaltyFeaturedRewards: FC = () => {
  const { formatMessage } = useIntl();
  const { data, loading } = useLoyaltyFeaturedRewardsQuery();
  const carouselRewards = useCarouselRewards({
    rewards: data?.allRewardsSections?.[0]?.rewardsList || [],
  });

  if (loading || !carouselRewards?.length) {
    return null;
  }

  return (
    <FeaturedRewardsContainer>
      <Title>{formatMessage({ id: 'featured' })}</Title>
      <RewardsCarousel rewards={carouselRewards} />
    </FeaturedRewardsContainer>
  );
};

export default LoyaltyFeaturedRewards;
